module.exports = __webpack_public_path__ + "img/login.7109f7a1.png";